<!-- =========================================================================================
  File Name: MemberView.vue
  Description: Member View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-member-view">

    <vs-alert color="danger" title="Member Not Found" :active.sync="member_not_found">
      <span>Member record with userID: {{ $route.params.userID }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'member-list'}" class="text-inherit underline">All Members</router-link>
      </span>
    </vs-alert>

    <div id="member-data" v-if="memberData">

      <vx-card title="회원 상세 정보" class="mb-base">

        <!-- Avatar -->
        <div class="vx-row">

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="member-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">ID</td>
                <td>{{ memberData.userID }}</td>
              </tr>
              <tr>
                <td class="font-semibold">이름</td>
                <td>{{ memberData.name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">전화번호</td>
                <td>{{ memberData.telephone }}</td>
              </tr>
              <tr>
                <td class="font-semibold">핸드폰번호</td>
                <td>{{ memberData.mobilephone }}</td>
              </tr>
              <tr>
                <td class="font-semibold">이메일</td>
                <td>{{ memberData.eMail }}</td>
              </tr>
              <tr>
                <td class="font-semibold">우편번호</td>
                <td>{{ memberData.zipCode }}</td>
              </tr>
              <tr>
                <td class="font-semibold">주소</td>
                <td>{{ memberData.zipName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">주소세부</td>
                <td>{{ memberData.zipDetail  }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">소속학원</td>
                <td>{{ memberData.instituteName  }}</td>
              </tr>
              <tr>
                <td class="font-semibold">사용자타입</td>
                <td>{{ userType }}</td>
              </tr>
              <tr>
                <td class="font-semibold">상태</td>
                <td>{{ status }}</td>
              </tr>
              <tr>
                <td class="font-semibold">가입일시</td>
                <td>{{ memberData.createDate }}</td>
              </tr>
              <tr>
                <td class="font-semibold">최종수정일시</td>
                <td>{{ memberData.lastUpdateDate }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 2 -->
          <div class="vx-col w-full flex justify-end" id="account-manage-buttons">
            <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" :to="{name: 'member-edit', params: { memberSeq: $route.params.memberSeq }}">수정</vs-button>
            <vs-button type="border" class="mr-4" color="danger" @click="confirmDeleteRecord">탈퇴처리</vs-button>
            <vs-button color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteCommonMember">완전삭제</vs-button>  
          </div>
        </div>

      </vx-card>
     
    </div>
  </div>
</template>

<script>
import { fetchData, putData, deleteData } from '@/api/module'
import customFormatter from '../../utils/customFormatter.js'

export default {
  components: {
    customFormatter
  },
  data () {
    return {
      memberData: null,
      member_not_found: false
    }
  },
  computed: {
    status () {
      return customFormatter.fomatterStatus(this.memberData.status)
    },
    userType () {
      return customFormatter.fomatterUserType(this.memberData.userType)
    }
  },
  methods: {
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '탈퇴 처리',
        text: `"${this.memberData.userID} (을/를) 탈퇴 처리하시겠습니까?"`,
        accept: this.deleteRecord,
        acceptText: '탈퇴'
      })
    },
    confirmDeleteCommonMember () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '회원 삭제',
        text: `"${this.memberData.userID} (을/를) 삭제하시겠습니까? 회원의 모든 데이터가 영구적으로 삭제됩니다."`,
        accept: this.deleteCommonMemberInfo,
        acceptText: '탈퇴'
      })
    },
    async deleteRecord () {
      try {
        const memberData = {
          status: 1,
          userID: this.memberData.userID
        }
        await putData('member/status', memberData)
        this.$router.push('/member/member-list')
        this.showDeleteSuccess()

      } catch (error) {
        
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    async deleteCommonMemberInfo () {
      try {
        await deleteData(`/member/${this.memberData.userID}`)
        this.$router.push('/member/member-list')

      } catch (error) {
        
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: '탈퇴 처리',
        text: '탈퇴 처리 되었습니다.'
      })
    }
  },
  async created () {
    try {
      const userID = this.$route.params.userID
      const { data } = await fetchData(`member/${userID}`)
      this.memberData = data.data
      // console.log(data);
    } catch (error) {
      this.$vs.notify({
        title: 'Error',
        text: error.response.data.msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      }) 
    }
  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-member-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

}

</style>
